import React, { useState, useEffect } from 'react';
import AutoAvaliacaoInfo1 from './AutoAvaliacaoInfo1';
import AutoAvaliacaoInfo2 from './AutoAvaliacaoInfo2';
import AutoAvaliacaoInstrucoes from './AutoAvaliacaoInstrucoes';
import {
    getMostrarNovamenteNivel,
    getMostrarNovamenteInstrucoes,
    getMostrarNovamenteNivelIniciar
} from '../../../services/SaudeBemEstar/SaudeEmocionalService';
import { useLocation, useNavigate } from 'react-router-dom';
import { RetornaAceiteTermoResponse } from '../../../interfaces/entities/RetornaAceiteTermoResponse';

export interface AutoAvaliacaoInfoPage {
    onNext: () => void;
    onBack: () => void
}

const AutoavaliacaoInfo: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [currentScreen, setCurrentScreen] = useState<string>('');
    const [screensToShow, setScreensToShow] = useState<string[]>([]);
    const isReturning = new URLSearchParams(location.search).get('isReturning');
    const shouldShowScreen = (response: RetornaAceiteTermoResponse | null) => response?.indAceite === 'N' || response?.indAceite === null;

    const checkScreens = async () => {
        const [nivelResponse, nivelIniciarResponse, instrucoesResponse] = await Promise.all([
            getMostrarNovamenteNivel(),
            getMostrarNovamenteNivelIniciar(),
            getMostrarNovamenteInstrucoes()
        ]);

        const screens = [];
        if (shouldShowScreen(nivelResponse)) screens.push('info1');
        if (shouldShowScreen(nivelIniciarResponse)) screens.push('info2');
        if (shouldShowScreen(instrucoesResponse)) screens.push('instrucoes');

        if (screens.length === 0) {
            if (isReturning) {
                navigate('/saudeBemEstar/unimedAcolhe/autoAvaliacao');
            } else {
                navigate('/saudeBemEstar/unimedAcolhe/autoAvaliacao/questoes');
            }
            return;
        }

        setScreensToShow(screens);
        setCurrentScreen(isReturning ? screens[screens.length - 1] : screens[0]);
    };

    useEffect(() => {
        checkScreens();
    }, [isReturning, navigate]);

    const handleNextScreen = async () => {
        await checkScreens();
        const currentIndex = screensToShow.indexOf(currentScreen);
        if (currentIndex < screensToShow.length - 1) {
            setCurrentScreen(screensToShow[currentIndex + 1]);
        } else {
            navigate('/saudeBemEstar/unimedAcolhe/autoAvaliacao/questoes');
        }
    };

    const handleBackScreen = async () => {
        await checkScreens();
        const currentIndex = screensToShow.indexOf(currentScreen);
        if (currentIndex > 0) {
            setCurrentScreen(screensToShow[currentIndex - 1]);
        } else {
            navigate('/saudeBemEstar/unimedAcolhe/autoAvaliacao');
        }
    };

    return (
        <div>
            {currentScreen === 'info1' && <AutoAvaliacaoInfo1 onNext={handleNextScreen} onBack={handleBackScreen} />}
            {currentScreen === 'info2' && <AutoAvaliacaoInfo2 onNext={handleNextScreen} onBack={handleBackScreen} />}
            {currentScreen === 'instrucoes' && <AutoAvaliacaoInstrucoes onNext={handleNextScreen} onBack={handleBackScreen} />}
        </div>
    );
};

export default AutoavaliacaoInfo;
